module.exports = "/images/storm-alt@3x.png?32a682ee669e630a2d5ee2740b091889";